import React, { useCallback, useEffect, useState } from "react";
import {
  FlexContainer,
  FlexWrapper,
  MainTemplateWrapper,
  MainTemplateWrapperWithLogo,
  paddingAdPreview,
  PreviewText,
  StreamTextContainer
} from "../../AdAssistant.styled";
import VideoImagePreview from "../video-image-preview/VideoImagePreview";
import LogoCompanyHeader from "../logo-company-header/LogoCompanyHeader";
import EditHoverLayer from "../edit-hover-layer/EditHoverLayer";
import { Store__System } from "@talentbait/shared-components";
import { withRefluxStore } from "../../../../Stores";
import AdAssistantStore from "../../AdAssistantStore";
import { BookMarkIcon, HeartIcon, MessageCircleIcon, SendIcon } from "../../../../Components/Icons";
import { ApplyButtonPortrait } from "./PortraitPreview.styled";
import { BlueRightArrow } from "../../../../Components/Icons/BlueRightArrow";
import UseDismissHoverLayer from "../use-dismiss-hover-layer/UseDismissHoverLayer";
import StatusIcon from "../status-icon/StatusIcon";
import { PreviewLocked } from "../../all-variants-modal/AllVariantsModal.styled";
import { useTranslation } from "react-i18next";

const FALLBACK_LOGO = "/images/jobhappier.png";
const COMPANY_NAME = "Job Happier";

const PortraitPreview = ({
  id,
  isTemplateVideo,
  dimensionsPreview,
  templateInputProps,
  autoCroppingImage,
  orientationSelected,
  videoDuration,
  TemplateComponent,
  toggleEditionModal,
  toggleAdSelection,
  toggleAdSelectionEdition,
  setIsAdPreviewHovered,
  isAdPreviewHovered,
  isUsed,
  isDismissed,
  // Store
  organization,
  editedAd,
  userProfile
}) => {
  const { t } = useTranslation();
  const [teaserText, setTeaserText] = useState("");

  const handleMouseEnter = useCallback(() => {
    setIsAdPreviewHovered?.(true);
  }, [setIsAdPreviewHovered]);

  const handleMouseLeave = useCallback(() => {
    setIsAdPreviewHovered?.(false);
  }, [setIsAdPreviewHovered]);

  useEffect(() => {
    if (editedAd?.text?.long) {
      setTeaserText(editedAd?.text?.long);
    } else {
      setTeaserText("");
    }
  }, [editedAd?.text?.long]);

  const portraitPreview = document?.getElementById("portrait-preview")?.getBoundingClientRect();
  const templateWrapperPadding = paddingAdPreview * 2;

  return (
    <MainTemplateWrapperWithLogo
      id={id}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      width={dimensionsPreview?.width}
      height={dimensionsPreview?.height}
      gap={7}
    >
      {editedAd.isLocked && editedAd.lockedUserId !== userProfile.userId ? (
        <PreviewLocked width={dimensionsPreview?.width} height={dimensionsPreview?.height}>
          Locked by {editedAd.lockedBy}
        </PreviewLocked>
      ) : (
        <>
          <LogoCompanyHeader logoSrc={FALLBACK_LOGO} companyName={COMPANY_NAME} isDark />
          <MainTemplateWrapper width={dimensionsPreview?.width} height={dimensionsPreview?.height}>
            <VideoImagePreview
              isTemplateVideo={isTemplateVideo}
              dimensionsPreview={dimensionsPreview}
              templateInputProps={templateInputProps}
              autoCroppingImage={autoCroppingImage}
              orientationSelected={orientationSelected}
              videoDuration={videoDuration}
              TemplateComponent={TemplateComponent}
            />
          </MainTemplateWrapper>
          {toggleEditionModal && (
            <EditHoverLayer
              isAdPreviewHovered={isAdPreviewHovered}
              toggleEditionModal={toggleEditionModal}
              width={portraitPreview?.width - templateWrapperPadding}
              height={portraitPreview?.height - templateWrapperPadding}
            />
          )}
          {toggleAdSelection && (
            <UseDismissHoverLayer
              isUsed={isUsed}
              isDismissed={isDismissed}
              isAdPreviewHovered={isAdPreviewHovered}
              toggleAdSelection={toggleAdSelection}
              toggleAdSelectionEdition={toggleAdSelectionEdition}
              width={portraitPreview?.width - templateWrapperPadding}
              height={portraitPreview?.height - templateWrapperPadding}
            />
          )}
          <StatusIcon isUsed={isUsed} isDismissed={isDismissed} />
          <FlexWrapper width={"100%"} align={"center"} style={{ marginTop: "-7px" }}>
            <ApplyButtonPortrait
              color={templateInputProps?.primaryTextColor}
              backgroundColor={templateInputProps?.primaryBackgroundColor}
            >
              <span>{t("Apply now!")}</span>
              <BlueRightArrow color={templateInputProps?.primaryTextColor} />
            </ApplyButtonPortrait>
          </FlexWrapper>
          <FlexContainer style={{ marginTop: "5px" }}>
            <FlexContainer justify={"flex-start"} gap={8}>
              <HeartIcon />
              <MessageCircleIcon />
              <SendIcon />
            </FlexContainer>
            <BookMarkIcon />
          </FlexContainer>
          <FlexWrapper justify={"flex-start"} align={"flex-start"}>
            <PreviewText fontSize={"var(--fs-sm)"} fontWeight={600}>
              {organization?.name}
            </PreviewText>
          </FlexWrapper>
          <StreamTextContainer>{teaserText}</StreamTextContainer>
        </>
      )}
    </MainTemplateWrapperWithLogo>
  );
};

export default withRefluxStore(
  PortraitPreview,
  [Store__System, AdAssistantStore],
  ["organization"]
);
